module.exports = __webpack_public_path__ + "static/media/defaultImage.dfe20795.jpg";